import { Component } from 'react';
import PropTypes from 'prop-types';
import EditorUtils from '../../utils/EditorUtils';
import AddLinkForm from './AddLinkForm';
import { Icon } from '@sb1/ffe-icons-react';
import linkIcon from '@sb1/ffe-icons/icons/open/300/md/link.svg';
import { Tooltip } from '../../../../tooltip/Tooltip';

export default class LinkButton extends Component {
    static propTypes = {
        placeholder: PropTypes.string,
        store: PropTypes.object.isRequired,
        ownTheme: PropTypes.object.isRequired,
        onRemoveLinkAtSelection: PropTypes.func.isRequired,
        AddLinkFormReplacer: PropTypes.func,
        urlInvalidError: PropTypes.string,
    };

    onMouseDown = (event) => {
        event.preventDefault();
    };

    onAddLinkClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { ownTheme, placeholder, onOverrideContent, AddLinkFormReplacer, urlInvalidError } = this.props;
        const content = (props) => (
            <AddLinkForm
                {...props}
                urlInvalidError={urlInvalidError}
                AddLinkFormReplacer={AddLinkFormReplacer}
                placeholder={placeholder}
                theme={ownTheme}
            />
        );
        onOverrideContent(content);
    };

    render() {
        const { theme, onRemoveLinkAtSelection } = this.props;
        const hasLinkSelected = EditorUtils.hasEntity(this.props.store.getEditorState(), 'LINK');
        const className = hasLinkSelected ? [theme.button, theme.active].join(' ') : theme.button;

        return (
            <Tooltip text="Sett inn lenke">
                <button
                    className={className}
                    onClick={hasLinkSelected ? onRemoveLinkAtSelection : this.onAddLinkClick}
                    type="button"
                >
                    <Icon fileUrl={linkIcon} />
                </button>
            </Tooltip>
        );
    }
}
